<template>
    <!--   </v-container>-->
    <v-sheet >
        <h2>Próximos lançamentos</h2>
    <br>

    <v-data-table :headers="headers" :items="products" :search="search"
                :footer-props="{itemsPerPageOptions:[100,200,500]}"
            >
                <template v-slot:item.artist="{item}">
                    <span v-if="item.artist">{{item.artist.name}}</span>
                </template>

                <template v-slot:item.cover="{item}">
                    <v-img width="70px" v-if="item.thumbnail" :src="get_cover_url(item)" />
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-btn icon text :to="{name:'product_edit_audio',params:{id:item.id}}">
                       &nbsp;<v-icon small class="mr-2">visibility</v-icon>
                    </v-btn>
                </template>
            </v-data-table>

           

    </v-sheet>
</template>

<script>
import ProductService from "../../../app/rest/products"

var productService = null;

export default {
    components:{ },
    data: () => ({
        search: '',
        products:[],      
        headers: [
            {
                text: "Capa",
                align: "left",
                sortable: false,
                value: "cover"
            },
            { text: "Nome", value: "name" },
            { text: "Artista principal", value: "artist" },
            { text: "UPC", value: "upc" },
            { text: "Data de lançamento", value: "release_date" },
            { text: "Data de Criação", value: "created_at" },            
            { text: "Ações", value: "actions" }
        ]
    }),    
      
    mounted () {
      
    },
    beforeCreate:function(){
        this.$store.dispatch("loading");
        productService = ProductService.build();
        //mostrar no calendário apenas os produtos prontos para subir
        productService.get_all({status:'published',naolancados:1}).then( e =>{
            if(e.status=="ok"){
                this.products = e.items.products;
                this.events = e.items.products;
            }

        }).catch( e =>{
            console.log(e);
        }).finally( () =>{
             this.$store.dispatch("loading", false);
        });
    },
    created:function(){
        this.today = this.get_date();
        this.focus = this.get_date();
      
    },
    methods:{
       
        get_cover_url(item) {
        return (item.thumbnail.indexOf("googleapis")>=0) ? 
                    item.thumbnail : process.env.VUE_APP_BASE_URL + item.thumbnail;
        }     
    }
}
</script>